'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _uuid = require('uuid');
var _events = require('@xmpp/events');
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
var _stanzaQueue = require('../infra/stanzaQueue');
var _stanzaQueue2 = _interopRequireDefault(_stanzaQueue);
var _constants = require('../../constants');
var _exceptions = require('../../exceptions');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var SafeSender = function (_Plugin) {
  _inherits(SafeSender, _Plugin);
  function SafeSender(entity) {
    _classCallCheck(this, SafeSender);
    var _this = _possibleConstructorReturn(this, (SafeSender.__proto__ || Object.getPrototypeOf(SafeSender)).call(this, entity));
    _this.handler = function (stanza) {
      var id = stanza.attrs.id;
      var handler = _this.handlers.get(id);
      if (!handler) {
        return;
      }
      var resolve = handler.resolve,
        reject = handler.reject,
        inputStanza = handler.inputStanza;
      var realStanza = SafeSender.getRealStanza(stanza);
      var type = realStanza.attrs.type;
      if (type === 'error') {
        var error = realStanza.getChild('error');
        if (!error) {
          reject(new _exceptions.ReceiveException('Unknown error', inputStanza, stanza));
        }
        var text = error.getChildText('text');
        var exception = new _exceptions.ReceiveException(text, inputStanza, stanza);
        Object.assign(exception, error.attrs);
        reject(exception);
      } else {
        resolve(stanza);
      }
      _this.handlers.delete(id);
    };
    _this.handlers = new Map();
    _this.entity.on(_constants.Events.STANZA, _this.handler);
    return _this;
  }
  _createClass(SafeSender, [{
    key: 'getRealTimeout',
    value: function getRealTimeout(timeout) {
      var realTimeout = timeout;
      if (!this.entity.internetIsConnected) {
        realTimeout = 1000;
      }
      return realTimeout;
    }
  }, {
    key: 'send',
    value: function send(stanza) {
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60 * 1000;
      if (!stanza.attrs.id) {
        stanza.attrs.id = (0, _uuid.v4)();
      }
      var deferred = this.queueStanza(stanza);
      this.configTimeout(deferred, this.getRealTimeout(timeout));
      return deferred.promise.then(function (response) {
        clearTimeout(deferred.timeout);
        return response;
      }).catch(function (error) {
        clearTimeout(deferred.timeout);
        throw error;
      });
    }
  }, {
    key: 'queueStanza',
    value: function queueStanza(stanza) {
      var _this2 = this;
      var deferred = new _events.Deferred();
      var resolve = deferred.resolve,
        reject = deferred.reject;
      var inputStanza = stanza.toString();
      var id = stanza.attrs.id;
      var stanzaFn = function stanzaFn() {
        _this2.handlers.set(id, {
          resolve: resolve,
          reject: reject,
          inputStanza: inputStanza
        });
        _this2.entity.send(stanza).catch(function (e) {
          _this2.manageError(stanza);
          if (_this2.entity.internetIsConnected) {
            reject(new _exceptions.SendException(e, stanza));
          } else {
            reject(new _exceptions.NoInternetException('NO_INTERNET', stanza));
          }
        });
      };
      this.stanzaQueue.processStanza(stanzaFn);
      deferred.stanza = stanza;
      deferred.stanzaFn = stanzaFn;
      return deferred;
    }
  }, {
    key: 'configTimeout',
    value: function configTimeout(deferred, ms) {
      var _this3 = this;
      var retries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var reject = deferred.reject,
        stanza = deferred.stanza,
        stanzaFn = deferred.stanzaFn;
      deferred.timeout = setTimeout(function () {
        if (_this3.shouldWaitStanza(retries)) {
          _this3.configTimeout(deferred, ms, retries - 1);
        } else {
          _this3.stanzaQueue.removeStanza(stanzaFn);
          _this3.manageError(stanza);
          if (_this3.entity.internetIsConnected) {
            reject(new _exceptions.TimeoutException('Timeout error to send stanza with status: ' + _this3.entity.getConnStatus(), stanza));
          } else {
            reject(new _exceptions.NoInternetException('NO_INTERNET', stanza));
          }
        }
      }, ms);
    }
  }, {
    key: 'shouldWaitStanza',
    value: function shouldWaitStanza(retries) {
      return retries && this.entity.isConnected();
    }
  }, {
    key: 'manageError',
    value: function manageError(stanza) {
      var id = stanza.attrs.id;
      stanza.attrs = Object.assign({}, stanza, {
        type: 'error'
      });
      this.handlers.delete(id);
      if (stanza.is('message') && stanza.getChildText('body') !== '') {
        this.entity.emit('sending', stanza);
      }
    }
  }], [{
    key: 'getRealStanza',
    value: function getRealStanza(stanza) {
      var event = stanza.getChild('event');
      if (event) {
        return event.getChild('items').getChild('item').getChild('message');
      }
      return stanza;
    }
  }]);
  return SafeSender;
}(_plugin2.default);
SafeSender.pluginName = 'safeSender';
SafeSender.deps = [_stanzaQueue2.default];
exports.default = SafeSender;